<template>
    <div class='shopping-trolley sub-main'>
        <div class='trolley-list warp'>
            <div class='total-pro'>全部商品 {{cartNumber > 0 ? cartNumber : ''}}</div>
            <div class='trolley-title'>
                <p>
                    <el-checkbox v-model="selectAll" @change='getAllProduct' :true-label='1' :false-label='0'/>全选
                </p>
                <p><b>商品名称</b></p>
                <p>商品属性</p>
                <p>单价</p>
                <p>数量</p>
                <p>小计</p>
                <p>操作</p>
            </div>
            <div class='trolley-body'>
                <div v-if="noGoods==false">
                    <div class='main-list' v-for='(it, index) in list' :key='index'>
                        <div class='main-shop' v-if='it.skus.length'>
                            <el-checkbox v-model="it.selected" @change='selectShop(it)' :true-label='1' :false-label='0'/>
                            <span class="goToStore" @click="toStore(it.shopId)">店铺: {{it.shopName}}</span>
                            <div class='discount' @mouseenter="showDiscount(it)" @mouseleave="hiddenDiscount(it)" v-if='false'>
                                优惠券
                                <div class='pop-box' v-if='it.playDiscount'>
                                    <div class='box-content'>
                                         <p class='title'>可领取的优惠券</p>
                                         <ul>
                                             <li v-for='(d, dIndex) in it.discountList' :key='dIndex'>
                                                 <p>¥{{d.count}}</p>
                                                 <p>
                                                     <span>{{d.discount}}</span>
                                                     <span>{{d.time}}</span>
                                                 </p>
                                                 <p>领取</p>
                                             </li>
                                         </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class='pro-list'>
                            <div class='pro-item' v-for='(kt, j) in it.skus' :key='j'>
                                <div class='item'><el-checkbox v-model="kt.selected" @change='selectProduct' :true-label='1' :false-label='0'/></div>
                                <div class='item'>
                                    <img :src="kt.image" alt="" @click="goToProductDetail(kt,it.shopId)">
                                    <div class='pro-des'>
                                        <div>
                                            <p @click="goToProductDetail(kt,it.shopId)">{{kt.productName}}</p>
                                            <p>
                                                <span>{{kt.sku}}</span>
                                                <span>{{kt.value}}</span>
                                            </p>
                                        </div>
                                        <p class='discounts'>限时优惠</p>
                                    </div>
                                </div>
                                <div class='item'>
                                    <p>¥ {{kt.price}}</p>
                                </div>
                                <div class='item'>
                                    <el-input-number :disabled="!kt.shelveState" v-model="kt.number" @change="handleChange(kt)" :min="1" :max="kt.stockNumber" :step=1 label="描述文字" size='small'></el-input-number>
                                </div>
                                <div class='item'>
                                    <p v-if="kt.shelveState">¥ {{kt.total}}</p>
                                    <p v-else class="fs20">(已下架)</p>
                                </div>
                                <div class='item'>
                                    <p @click='confirDelete(kt)' v-throttle>删除</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="noproduct" v-else>
                    <img src="../../../static/image/noorder@2x.png" alt="">
                    <p class="fs20 font-color-999">你的购物车还没有宝贝哦～</p>
                </div>

                <div class='trolley-footer'>
                    <div class='item'>
                        <span @click='confirDelete(selectedList, true)' class='hover' v-throttle>删除</span>
                    </div>
                    <div class='item'>
                        <span class="clearBtn" @click="clearListFn">清除失效的宝贝</span>
                    </div>
                    <div class='item'>
                        已选商品
                        <span>{{selectedList.length}}</span>
                        件
                    </div>
                    <div class='item'>
                        <p>
                            合计 (不含运费) :
                            <span> ¥ {{totalProice.toFixed(2)}}</span>
                        </p>
                        <p>优惠券: ¥0.00</p>
                    </div>
                    <div class="item hover" @click='submitOrder' v-throttle>
                        结算
                    </div>
                </div>
            </div>
        </div>
        <delete-goods :delete-opt='deleteOpt' @close='closePop' v-if='deleteOpt.visiable' @confirm='deleteGood'/>
    </div>
</template>

<script>
import {listSearchMixin} from '../../config/mixin'
import api from '@/api'
import CereHeader from '../../components/canvasShow/cereshop/pc/header'
import DeleteGoods from './deleteGoods.vue'
import {mapGetters, mapMutations} from 'vuex'
import Cookie from 'js-cookie'
export default {
  components: { CereHeader, DeleteGoods },
  mixins: [listSearchMixin],
  data () {
        return {
            deleteOpt: {
                visiable: false
            },
            selectAll: 0,
            playDiscount: false,
            list: [],
            // 已选择的商品
            selectedList: [],
            // 商品总价
            totalProice: 0,
            noGoods: false
        }
    },
    created () {
      if (!Cookie.get('token')) {
        this.$message.warning('请先登录')
        this.$store.commit('resetVuex')
        this.$router.push({path: '/login'})
      } else {
        this.getTrolleyList()
      }
        // this.initList()
    },
    computed: {
      ...mapGetters([
        'cartNumber'
      ])
    },
    methods: {
      ...mapMutations({
        setShoppingCart: 'SET_SHOPPINGCART',
        setCartNumber: 'SET_CARTNUMBER'
      }),
        // 初始化购物车数据
        initList () {
        let cartNumber = 0
          this.list.forEach(j => {
            cartNumber = cartNumber + j.skus.length
            j.skus.forEach(k => {
              this.selectProduct(true)
            })
          })
          this.setCartNumber(cartNumber)
        },
        // 购物车列表
        async getTrolleyList () {
          const rLoading = this.openLoading()
            const vm = this
            const params = {
                url: api.getTrolleyList,
                method: 'GET'
            }
            vm.sendReq(params, res => {
                const d = res.data
                if (res.data.length) {
                    this.noGoods = false
                } else {
                    this.noGoods = true
                }
                if (d.length) {
                  this.list = d
                  this.setShoppingCart(d)
                  this.initList()
                }
              rLoading.close()
            })
        },
        // 选择商品
        selectProduct (flag) {
            console.log(flag)
            this.getSelectedProduct(flag)
            this.setShop()
            this.setselectAll()
        },
        // 选择商铺
        selectShop (shop) {
            this.setProduct(shop)
            this.getSelectedProduct()
            this.setselectAll()
        },
        // 全选
        getAllProduct () {
            this.list.forEach(j => {
                this.$set(j, 'selected', this.selectAll)
                j.skus.forEach(k => {
                    this.$set(k, 'selected', this.selectAll)
                })
            })
            this.getSelectedProduct()
        },
        clearListFn () {
        this.list.forEach((i) => {
          i.forEach((j) => {
            if (j.shelveState) {
            }
          })
        })
        },
        // 处理店铺下的商品选择状态
        setProduct (shop) {
            this.list.forEach((j) => {
                if (j.shopId === shop.shopId) {
                    j.skus.forEach(k => {
                        this.$set(k, 'selected', j.selected)
                    })
                }
            })
        },
        // 店铺下的商品全选时, 更新店铺的选中状态
        setShop () {
            this.list.forEach(j => {
                const flag = j.skus.findIndex(item => !item.selected)
                this.$set(j, 'selected', flag < 0 ? 1 : 0)
            })
        },
        // 店铺全选时, 更新全选状态
        setselectAll () {
            const temp = this.list.findIndex(item => !item.selected)
            this.selectAll = temp < 0
        },
        // 选择的商品集合
        getSelectedProduct () {
            let params
            let shopCarts = []
            this.list.forEach((j, i) => {
                let skus = []
                j.skus.forEach((k, n) => {
                    const index = this.selectedList.findIndex(item => item.skuId === k.skuId)
                    this.$set(k, 'total', k.price * k.number)
                    if (k.selected && index < 0) {
                        this.selectedList.push(k)
                    }
                    if (!k.selected && index > -1) {
                        this.selectedList.splice(index, 1)
                    }
                    skus[n] = {
                        skuId: k.skuId,
                        selected: k.selected
                    }
                })
                shopCarts[i] = {
                    shopId: j.shopId,
                    skus
                }
            })
            this.getTotalPrice()
            // 将选择的商品上传服务
            params = {
                url: api.selectGood,
                data: {
                    shopCarts
                },
                method: 'PUT'
            }
            // 是否是手动选择选商品
            this.sendReq(params, res => {
                // console.log(res, '选择')
            })
        },
        // 计算商品总价
        getTotalPrice () {
            let sum = 0
            this.selectedList.forEach(item => {
                sum += item.total
            })
            this.totalProice = sum
        },
        // 确认是否删除商品
        confirDelete (info, flag) {
            if (flag && !info.length) return this.$message.warning('请选中需要删除的商品')
            this.deleteOpt = {
                visiable: true,
                info,
                all: flag
            }
        },
        // 删除单个商品
        deleteGood (delData) {
            // const id = info.skuId
            const goodList = delData.all ? delData.info : [delData.info]
            let ids = []
            let params
            goodList.forEach(it => {
                let id = it.skuId
                ids.push(id)
                this.list.map(j => {
                    j.skus.map(k => {
                        if (k.skuId === id) {
                            j.skus.splice(j.skus.findIndex(item => item.skuId === id), 1)
                        }
                    })
                })
            })
          let number = 0
          this.list.map(j => {
            j.skus.map(k => {
              number = number + 1
            })
          })
            this.setCartNumber(number)
            params = {
                url: api.deleteGoods,
                method: 'DELETE',
                data: {
                    ids: ids
                }
            }
            this.selectedList = []
            this.getSelectedProduct()
            this.closePop()
            this.sendReq(params, res => {
                this.$message.success('删除成功')
            })
            console.log(this.list)
            let flag = null
            this.list.map(item => {
                flag = item.skus.length
            })
            if (flag) {
                this.noGoods = false
            } else {
                this.noGoods = true
            }
        },
        // 修改购物车商品数量
        handleChange (kt) {
            const params = {
                url: api.updateGoodNum,
                method: 'PUT',
                data: {
                    skuId: kt.skuId,
                    number: kt.number
                }

            }
            this.sendReq(params, res => {
                // console.log(res, 1231)
            })
            this.$set(kt, 'total', kt.productPrice * kt.number)
            this.getSelectedProduct()
        },
        // 结算
        submitOrder () {
            let shops = []
            let down = false
            this.list.forEach((j, i) => {
                let skus = []
                j.skus.forEach((k, n) => {
                    if (!k.shelveState && k.selected) {
                        down = true
                        return this.$message.warning('选中的商品中有下架商品')
                    }
                    if (k.selected) {
                        skus.push({
                            skuId: k.skuId,
                            number: k.number
                        })
                    }
                })
                if (skus.length) {
                    shops.push({
                        shopId: j.shopId,
                        skus
                    })
                }
            })
            if (down) {
                return
            }
            if (this.selectedList.length) {
                return this.$router.push({name: 'placeOrder',
                    query: {
                        type: 2,
                        shops: JSON.stringify(shops),
                        ifWork: 0,
                        activityType: 0
                    }
                })
            }
            return this.$message.warning('请至少选中一件商品')
        },
        showDiscount (kt) {
            this.$set(kt, 'playDiscount', true)
        },
        hiddenDiscount (kt) {
            this.$set(kt, 'playDiscount', false)
        },
        closePop () {
            this.deleteOpt = {
                visiable: false
            }
        },
        // 跳转到商品详情
      goToProductDetail (item, id) {
          let data = {
              shopId: id,
              productId: item.productId,
              skuId: item.skuId
          }
        this.$router.push({
            path: '/productDetail',
            query: {
                proData: JSON.stringify(data)
            }
        })
      },
      // 跳转到店铺
      toStore (id) {
        console.log(id, 'id')
        this.$router.push({
          path: '/store', query: {shopId: id}
        })
      }
    }
}
</script>

<style scoped lang='scss'>
.shopping-trolley {
    width: 80%;
    margin: 20px auto;
    .hover:hover {
        cursor: pointer;
    }
    .trolley-list {
        .total-pro {
            font-size:20px;
            font-weight: bold;
            color: #FF7800;
            margin-bottom: 20px;
        }

        .trolley-title {
            display: flex;
            background-color: #F1F2F7;
            height: 54px;
            line-height: 54px;
            padding: 0 0px;
            p {
                margin: 0;
                color: #333;
                font-size: 16px;
                flex: 1;
              text-align: center;
                &:nth-child(2) {
                  flex:3;
                  text-align: left;
                  b {
                    font-weight: normal;
                    padding-left: 60px;
                  }
                }
              &:nth-child(3) {
                flex:1;
                text-align: left;
              }
            }
          >>> .el-checkbox {
            margin-right: 5px;
          }
        }

        .trolley-body {
            .main-list {
                .main-shop {
                  color: #333;
                  font-size: 16px;
                  margin:20px 0 32px;
                  padding-left: 30px;
                  .goToStore {
                    cursor: pointer;
                  }
                    .discount {
                        color: #FF7800;
                        font-size: 14px;
                        padding: 8px 9px;
                        display: inline-block;
                        border: 1px #FF7800 dashed;
                        margin-left: 20px;
                        position: relative;
                        &:hover {
                            cursor: pointer;
                        }
                        .pop-box {
                            position: absolute;
                            left: 0;
                            top: 25px;
                            z-index: 2;
                            padding-top: 30px;
                            .box-content {
                                background: #fff;
                                padding: 20px;
                                border-radius: 4px;
                                border: .5px #FF7800 solid;
                                min-height: 200px;
                                min-width: 500px;
                                position: relative;
                                &::before {
                                    position: absolute;
                                    content:'';
                                    width: 0; height: 0;
                                    border-bottom: 12px solid #FF7800;
                                    border-left: 8px solid transparent;
                                    border-right: 8px solid transparent;
                                    top: -13px;
                                    left: 25px;
                                }
                                &::after {
                                    position: absolute;
                                    content:'';
                                    width: 0; height: 0;
                                    border-bottom: 11px solid #fff;
                                    border-left: 7px solid transparent;
                                    border-right: 7px solid transparent;
                                    top: -10px;
                                    left: 25.5px;
                                }
                                .title {
                                    font-size: 14px;
                                    color: #333;
                                }
                                ul {
                                    li {
                                        height: 40px;
                                        line-height: 40px;
                                        margin-top: 20px;
                                        // overflow: hidden;
                                        p {
                                            float: left;
                                            &:nth-child(1) {
                                                width: 80px;
                                                height: 40px;
                                                text-align: center;
                                                border: 1px solid #FD5B5B;
                                                border-radius: 4px;
                                                color: #FD5B5B;
                                                font-size:16px;
                                                font-weight: bold;
                                                box-sizing: border-box;
                                            }
                                            &:nth-child(2) {
                                                span {
                                                    display: block;
                                                    line-height: 20px;
                                                    color: #666;
                                                    font-size:14px;
                                                }
                                            }
                                            &:nth-child(3) {
                                                width: 80px;
                                                height: 40px;
                                                text-align: center;
                                                color: #fff;
                                                font-size:16px;
                                                font-weight: bold;
                                                background: #FD5B5B;
                                                border-radius: 4px;
                                            }
                                            &:nth-child(n+2) {
                                                margin-left: 20px;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                .pro-list {
                    border: 1px solid #E5E5E5;
                    .pro-item {
                        display: flex;
                        padding: 36px 0;
                         &:nth-child(n+2) {
                                border-top: 1px solid #E5E5E5;
                         }
                        .item {
                            flex: 1;
                          p {
                            text-align: center;
                          }
                            &:nth-child(1) {
                                display: flex;
                                align-items: center;
                                justify-content: center;
                            }
                            &:nth-child(2) {
                              p {
                                text-align: left;
                                cursor: pointer;
                              }
                                flex: 4;
                                img,.pro-des {
                                    float:left;
                                }
                                img {
                                    width: 100px;
                                    height: 100px;
                                    box-sizing: border-box;
                                  cursor: pointer;
                                }
                                .pro-des {
                                    width: calc(100% - 100px);
                                    box-sizing: border-box;
                                    padding-left: 20px;
                                    height: 100%;
                                    position: relative;
                                    div {
                                        p {
                                            float: left;
                                            overflow: hidden;
                                            &:nth-child(1) {
                                                width: 67%;
                                                color: #333;
                                                font-size: 16px;
                                                padding-right: 30px;
                                                box-sizing: border-box;
                                            }
                                            &:nth-child(2) {
                                                width: 33%;
                                                span {
                                                    display: block;
                                                    font-size: 16px;
                                                    color: #999;
                                                }
                                            }
                                        }
                                    }
                                    p.discounts {
                                        position: absolute;
                                        bottom: 0;
                                        left: 20px;
                                        clear: both;
                                        background: #FFF2ED;
                                        font-size: 14px;
                                        color: #FF7800;
                                        border-radius: 2px;
                                        padding: 4px 7px;
                                        display: inline-block;
                                    }
                                }
                            }
                            &:nth-child(5) {
                                color: #FF7800;
                                font-weight: bold;
                            }
                            &:last-child {
                                &:hover {
                                    cursor: pointer;
                                }
                            }
                        }
                    }
                }
            }
            .noproduct{
                width: 100%;
                text-align: center;
                padding: 200px 0;
            }
        }

        .trolley-footer {
            margin: 60px 0 100px;
            background-color: #F1F2F7;
            height: 80px;
            display: flex;
            font-size: 16px;
          align-items: center;
            color: #333;
            .item {
                flex: 1;
              .clearBtn {
                cursor: pointer;
              }
                &:nth-child(1) {
                   padding-left: 40px;
                }
                &:nth-child(4) {
                    span {
                        color: #FF7800;
                        font-size:20px;
                    }
                }
                &:nth-child(4) {
                    flex: 3;
                    padding-right: 15px;
                    p {
                        text-align: right;
                      line-height: normal;
                        span {
                            color: #FF7800;
                            font-size:20px;
                        }
                    }
                }
                &:nth-child(n-2) {
                    line-height: 40px;
                }
                &:last-child {
                    width: 100px;
                    text-align: center;
                    font-size: 20px;
                    color: #fff;
                    background-color:#FF7800;
                    line-height: 80px;
                }
              >>> .el-checkbox {
                margin-right: 5px;
              }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/shopping-trolley/index.vue